module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00093-fs8.c6cb99f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00093-fs8.png
// module id = 246
// module chunks = 0